import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import { useValidateLookupTable } from "components/lookup-tables/hooks/useLookupTablesAPI";
const DEFAULT_VALUE_FIELDS = ["default_single_value", "default_multi_value"];
const useDefaultValueValidation = () => {
  var _a;
  const { values, status, setStatus } = useFormikContext();
  const { validateLookupTable } = useValidateLookupTable();
  const latestRequest = useRef(0);
  useEffect(
    () => () => {
      latestRequest.current += 1;
    },
    []
  );
  const defaultValueErrors = (_a = status == null ? void 0 : status.defaultValueErrors) != null ? _a : {};
  const validateDefaultValues = (table = values) => {
    latestRequest.current += 1;
    const request = latestRequest.current;
    return validateLookupTable(table).then(({ errors }) => {
      if (request !== latestRequest.current) return;
      setStatus({
        defaultValueErrors: Object.fromEntries(
          DEFAULT_VALUE_FIELDS.filter((field) => {
            var _a2;
            return (_a2 = errors[field]) == null ? void 0 : _a2.length;
          }).map((field) => [field, errors[field][0]])
        )
      });
    }).catch(() => {
    });
  };
  const clearDefaultValueError = (field) => {
    latestRequest.current += 1;
    if (defaultValueErrors[field]) {
      setStatus({ defaultValueErrors: { ...defaultValueErrors, [field]: void 0 } });
    }
  };
  const hasDefaultValueErrors = Object.values(defaultValueErrors).some(Boolean);
  return { defaultValueErrors, hasDefaultValueErrors, validateDefaultValues, clearDefaultValueError };
};
export default useDefaultValueValidation;
